import "./ArticleCard.css";
import { forwardRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface ArticleCardProps {
    id: string;
    displayId: number;
    articleTitle: string;
    articleDescription: string;
    imageUrl: string;
    published: string;
    useDefaultImage: boolean;
}

const truncateText = (text: string, length: number) => {
    return text.length > length ? text.substring(0, length) + "..." : text;
};

const ArticleCard = forwardRef<HTMLDivElement, ArticleCardProps>(
    ({ displayId, imageUrl, articleDescription, articleTitle, published, useDefaultImage }) => {

        const truncatedDescription = truncateText(articleDescription, 150);
        return (
            <Box className="article-card-container article-card-background">
                <Box className="article-image-container">
                    <img
                        src={useDefaultImage ? `${process.env.REACT_APP_ARTICLES_DEFAULT_IMAGE_URL}` : `${process.env.REACT_APP_STATIC_FILE_ROUTE}/${imageUrl}`}
                        alt="Card Visual"
                        style={{ display: "block", width: "100%" }}
                    />
                </Box>
                <Box
                    className="article-card-title-container"
                    id={`${displayId}-container`}
                >
                    <Box
                        className="article-card-title"
                        id={`${displayId}-title`}
                    >
                        <Typography
                            className="article-card-title"
                            sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px', lg: '32px' } }}
                        >
                            {articleTitle}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    className="article-card-info-container"
                    id={`${displayId}-container`}
                >
                    <Box
                        className="article-card-info"
                        id={`${displayId}-title`}
                    >
                        <Typography
                            className="article-card-info"
                            sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' } }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: truncatedDescription }} />
                        </Typography>
                    </Box>
                    <Box className="article-card-extras">
                        {/* Published Date */}
                        <Typography
                            className="article-card-published"
                            variant="body2"
                        >
                            Published on: {new Date(published).toLocaleDateString()}
                        </Typography>

                        {/* Read More Button */}
                        <Button
                            variant="contained"
                            color="primary"
                            component={Link}
                            to={`/article/${displayId}`}
                            className="article-card-read-more"
                        >
                            Read more
                        </Button>
                    </Box>
                </Box>
            </Box>
        );
    }
);

export default ArticleCard;